import React, {useEffect, useRef} from 'react'
import './modal-dropdown-menu-fall-2023.css'
const ModalDropdownMenuFall2023 = ({menuItems, setOpenDropdown, sections}) => {

    const modalRef = useRef()

    useEffect(() => {
        const closeModal = (e) => {
            if (modalRef.current && !modalRef.current.contains(e.target)) {
                setOpenDropdown(false)
            }
        }
        document.addEventListener('mousedown', closeModal)
        return () => {
            document.removeEventListener('mousedown', closeModal)
        }
    }, [])

    const clickMenuItem = (item) => {
        item.onClick()
        setOpenDropdown(false)
    }

    const MenuItem = ({item}) => <div className='modal-dropdown-menu-fall-2023__menu-item' style={item.accent ? {color: '#60A5FA'} : {color: '#334155'}} onClick={() => clickMenuItem(item)}>{item.label}</div>

    if(sections?.length > 0) {
        return (
            <div ref={modalRef} className='modal-dropdown-menu-fall-2023__wrapper'>
                {sections.map((section, index1) => 
                    <div key={index1}>
                        {menuItems.map((item, index) => (item.section === 0 || !item.section) && <MenuItem item={item} key={index} />)}
                        <div className='modal-dropdown-menu-fall-2023__section' key={index1}>{Object.keys(section)}</div>
                        {menuItems.map((item, index) => item.section === section[Object.keys(section)] && <MenuItem item={item} key={index} />)}
                    </div>
                )}
            </div>
        )
    } else {
        return (
            <div ref={modalRef} className='modal-dropdown-menu-fall-2023__wrapper'>
                {menuItems.map((item, index) => <MenuItem item={item} key={index}/>)}
            </div>
        )
    }
}
export default ModalDropdownMenuFall2023